import { useEffect, useState } from 'react';

// Live `matchMedia` state for chrome that renders different markup (not just
// different styles) per breakpoint — the header's mobile bars vs the desktop row
// (design `isMobile = vw < 768`). Where only styling changes, CSS media queries are
// used instead. Without matchMedia (tests, very old engines) the query reads false,
// i.e. the desktop layout.
export const MOBILE_QUERY = '(max-width: 767px)';

function read(query: string): boolean {
  return typeof window !== 'undefined' && typeof window.matchMedia === 'function' ? window.matchMedia(query).matches : false;
}

export function useMediaQuery(query: string): boolean {
  const [matches, setMatches] = useState(() => read(query));

  useEffect(() => {
    if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') return;
    const mq = window.matchMedia(query);
    const onChange = () => setMatches(mq.matches);
    onChange();
    mq.addEventListener('change', onChange);
    return () => mq.removeEventListener('change', onChange);
  }, [query]);

  return matches;
}
